import React, { useEffect } from "react";
import { Field, Form, Formik } from "formik";
import {
  CheckBox,
  GalleryField,
  TextField,
  Select,
  Loading,
  TextArea,
} from "components/form";
import { required, validationWrapper, number } from "lib/formValidations";
import Modal from "components/Modal";
import * as Icons from "react-feather";

const EditSlide = (props) => {
  const { show, close, submit, item, setSlides, slides } = props;

  useEffect(() => {
    // Any additional logic or fetching can be placed here if needed.
  }, []);

  return (
    <Modal show={show} title="ویرایش اسلاید" handleClose={close}>
      <Formik
        initialValues={item}
        onSubmit={(values) => {
          const updatedSlides = slides?.map((slide) =>
            slide?.id === item?.id ? { ...slide, ...values } : slide
          );

          submit(values);

          setSlides(updatedSlides);

          close();
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty, values, setFieldValue }) => (
          <Form>
            <div className="box rounded py-3">
              values
              <div className="p-3 justify-aroundintro-x">
                <div className="col-span-2 md:grid md:grid-cols-2 md:gap-2">
                  <Field
                    label="ترتیب نمایش"
                    name="order"
                    component={TextField}
                    type="number"
                    validate={(value) => validationWrapper(value, number)}
                  />
                  <Field
                    placeholder="لینک"
                    label="لینک :"
                    name="link"
                    component={TextField}
                  />
                  <Field
                    placeholder="عنوان اسلاید"
                    label="عنوان اسلاید :"
                    name="translations.fa.title"
                    component={TextField}
                  />
                  <Field
                    placeholder="عنوان انگلیسی"
                    label="عنوان انگلیسی :"
                    name="translations.en.title"
                    component={TextField}
                  />

                  <Field
                    placeholder="عنوان لینک"
                    label="عنوان لینک :"
                    name="translations.fa.linkTitle"
                    component={TextField}
                  />
                  <Field
                    placeholder="عنوان لینک"
                    label="عنوان لینک :"
                    name="translations.en.linkTitle"
                    component={TextField}
                  />

                  <Field
                    placeholder="توضیحات"
                    label="توضیحات :"
                    name="translations.fa.summary"
                    component={TextArea}
                  />
                  <Field
                    placeholder="توضیحات انگلیسی"
                    label="توضیحات انگلیسی :"
                    name="translations.en.summary"
                    component={TextArea}
                  />
                </div>

                <div className="w-full flex justify-between">
                  <div className="w-full mt-3">
                    <Field
                      label="مدیا"
                      name="media"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>

                <button className="btn btn-sm btn-primary" type="submit">
                  ویرایش اسلاید
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default EditSlide;
